import { Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToolbarBridgeService {
  private _portalContent = signal<TemplateRef<unknown> | null>(null);
  readonly portalContent = this._portalContent.asReadonly();

  setContents(template: TemplateRef<unknown> | null): void {
    console.log('setting contents');
    this._portalContent.set(template);
  }
}
